import { ReactNode } from 'react'
import { Modal } from 'antd'
import { CloseIcon2 } from 'components/Icons'
import { DialogContent, DialogStyle } from './styles'

interface IProps {
  children: ReactNode,
  visible: boolean,
  onClose?: () => void
}

const Dialog = (props: IProps) => {
  const { visible, onClose, children } = props

  return (
    <Modal
      className="dialog"
      closeIcon={<CloseIcon2 />}
      visible={visible}
      footer={null}
      onCancel={() => onClose && onClose()}
      centered
      closable
      maskClosable
    >
      <DialogContent>
        <DialogStyle />

        {children}
      </DialogContent>
    </Modal>
  )
}

export default Dialog
